// extracted by mini-css-extract-plugin
module.exports = {"shadow":"input_shadow__1cm2u","_title":"input__title__2asBS","shadow-05":"input_shadow-05__1LkuK","input":"input_input__wPMCr"};